import { ProductV2, formatProductPrice, isDefined } from '@common'

import { useMarketContext } from '../../../../contexts/MarketContext'
import { useLocale } from '../../../locale/useLocale'

const useFormattedPriceTexts = (products: Array<ProductV2>) => {
  const locale = useLocale()
  const market = useMarketContext('useFormattedPriceTexts')

  return products.map((product) => formatProductPrice(product, market, locale))
}

const getTextScalingRatio = (texts: string[], limitForSmall: number) => {
  const xsLimit = limitForSmall + 2
  const xxsLimit = xsLimit + 2
  const longest = Math.max(...texts.map((t) => t.length))
  return longest > xxsLimit ? 'XXSmall' : longest > xsLimit ? 'XSmall' : longest > limitForSmall ? 'Small' : undefined
}

export const usePriceTextScalingRatio = (products: Array<ProductV2>, baseLimit = 9) => {
  const texts = useFormattedPriceTexts(products)
  return texts ? getTextScalingRatio(texts.filter(isDefined), baseLimit) : undefined
}
